import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ShortcutHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!event.key) return;
      const key = event.key.toLowerCase();

      // 🚫 Don't trigger while typing
      const activeElement = document.activeElement;
      const tag = activeElement?.tagName;
      const isTyping =
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        activeElement?.isContentEditable;

      if (isTyping) return;

      const shortcuts = [
        // Ctrl + Alt combinations
        { ctrl: true, alt: true, key: "t", route: "/diagnosis/transaction/pathology-test-value-entry/add" },
        { ctrl: true, alt: true, key: "r", route: "/diagnosis/transaction/radiology-test-value-entry/add" },

        // Ctrl + Letters
        { ctrl: true, key: "m", route: "/diagnosis/transaction/lab-registration-multiple/add" },
        { ctrl: true, key: "b", route: "/ipd/transaction/ipd-bill-charges-entry/add" },

        // Ctrl + Function Keys
        { ctrl: true, key: "f1", route: "/medical-store/transaction/sale-bill-entry/add" },
        { ctrl: true, key: "f5", route: "/opd/transaction/opd-entry/add" },
        { ctrl: true, key: "f6", route: "/ipd/transaction/ipd-entry/add" },
        { ctrl: true, key: "f7", route: "/diagnosis/transaction/lab-registration-entry/add" },
        { ctrl: true, key: "f8", route: "/ipd/transaction/payment-receive-entry/add" },
        { ctrl: true, key: "f9", route: "/ipd/transaction/patient-history-entry/add" },
        { ctrl: true, key: "f11", route: "/opd/transaction/opd-charges-entry/add" },
        { ctrl: true, key: "f12", route: "/ipd/helpdesk/patient-status" },
      ];

      shortcuts.forEach((shortcut) => {
        const match =
          (!!shortcut.ctrl === event.ctrlKey) &&
          (!!shortcut.alt === event.altKey) &&
          event.key.toLowerCase() === shortcut.key;

        if (match) {
          event.preventDefault();
          navigate(shortcut.route); // 🔁 Replace with your actual routes
        }
      });
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  return null;
};

export default ShortcutHandler;
